import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { ErrorData, PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ProductListItem } from '../models/product-list-item';
import { bestLocaleSelector } from '../../../../../common/selectors/locale-selectors';

export const PRODUCT_LIST_START_GET_ITEMS = 'PRODUCT_LIST_START_GET_ITEMS';
export const PRODUCT_LIST_RECEIVE_ITEMS = 'PRODUCT_LIST_RECEIVE_ITEMS';
export const PRODUCT_LIST_ERROR = 'PRODUCT_LIST_ERROR';
export const PRODUCT_LIST_RESET = 'PRODUCT_LIST_RESET';

const receiveProducts = (products: PaginatedResponse<ProductListItem>) => {
    return {
        type: PRODUCT_LIST_RECEIVE_ITEMS,
        products,
    };
};

const error = (errorData?: ErrorData) => ({
    type: PRODUCT_LIST_ERROR,
    errorData,
});

export const reset = () => {
    return {
        type: PRODUCT_LIST_RESET,
    };
};

export const getProductItems = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: PRODUCT_LIST_START_GET_ITEMS });

        const response = await api.product.listItems.getListItems(
            getState().settings.currency,
            bestLocaleSelector(getState()),
            searchParams
        );

        if (response.success) {
            dispatch(receiveProducts(response.result));
        } else {
            dispatch(error(response.error));
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
